<cap-list-loader [hasRight]="hasAnyAdressPermission" [listLoader]="listLoader" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail-manual">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      {{ "Art" | translate }}
    </th>
    <th>
      {{ "Adresse" | translate }}
    </th>
  </tr>
</ng-template>
<ng-template #tableRows>
  @for (address of listLoader?.items; track address) {
    <tr>
      <td>{{ address.personAdresseArt | translate }}</td>
      <td>
        <cap-kompakt-personenadresse
          [auskunftsperre]="auskunftsperre"
          [entry]="entry"
          [format]="'PERSONENADRESSE_TYP01'"
          [item]="address"
          style="display: block">
        </cap-kompakt-personenadresse>
      </td>
    </tr>
  }
</ng-template>
